export default __webpack_public_path__ + "static/media/acceso.023b0637.svg";